export default "__VITE_ASSET__DK$HrChP__"